<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>협회 소개</p></li>
            <li><p>임원 소개</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>임원 소개</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="rule_list">
            <ul class="rule_list_ul">
              <li class="rule_list_li" v-for="(item, index) in list" :key="index">
                <div class="rule_list_ttl">
                  <h3 class="h3">{{ item.employee.position }}</h3>
                </div>
                <div class="rule_list_con">
                  <div class="table">
                    <div class="row head">
                      <div class="cell fix210"><p>협회 직책</p></div>
                      <div class="cell fix210"><p>이름</p></div>
                      <div class="cell"><p>소속</p></div>
                      <div class="cell fix240"><p>직위</p></div>
                    </div>
                    <div class="page_con" v-if="$Util.isEmpty(item.employeeDetail)">
                      <div class="empty_wrap">
                        <div class="empty">
                          <span>내역이 존재하지 않습니다.</span>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-for="(empDetail, index2) in item.employeeDetail" :key="index2">
                      <div class="cell fix210"><p>{{ empDetail.position }}</p></div>
                      <div class="cell fix210"><p>{{ empDetail.employeeName }}</p></div>
                      <div class="cell"><p>{{ empDetail.affiliation }}</p></div>
                      <div class="cell fix240"><p>{{ empDetail.spot }}</p></div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'about-exctv-index',
  description: '임원소개',
  data() {
    return {
      list: []
    }
  },
  async created() {
    const res = await this.$IntroSvc.fetchEmployeeList()
    console.log('res', res)
    if(res.code === 1) {
      this.list = res.entity.list
    }
  }
}
</script>

<style scoped></style>
